import React from "react";

export const PlatformIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M4.35429 8.6964C4.13377 8.91691 3.77628 8.917 3.55566 8.6966L1.56424 6.7071C1.17339 6.31663 1.17324 5.6832 1.56389 5.29254L3.55101 3.30543C3.77429 3.08215 4.13619 3.08182 4.35988 3.30468C4.58416 3.52813 4.5845 3.89119 4.36063 4.11506L2.4662 6.00949L4.35429 7.89758C4.57487 8.11817 4.57487 8.47581 4.35429 8.6964ZM8.44888 8.69455C8.22561 8.91783 7.8637 8.91817 7.64001 8.6953C7.41573 8.47185 7.41539 8.10879 7.63926 7.88493L9.5337 5.99049L7.6456 4.1024C7.42502 3.88181 7.42502 3.52417 7.6456 3.30358C7.86612 3.08307 8.22361 3.08298 8.44423 3.30339L10.4357 5.29289C10.8265 5.68335 10.8267 6.31678 10.436 6.70744L8.44888 8.69455Z"
      fill="#5B5B5B"
    />
  </svg>
);
